export const consentKey = 'cookieStateV5';
function readStoredConsent() {
    try {
        const consentStateString = localStorage.getItem(consentKey);
        return consentStateString ? JSON.parse(consentStateString) : null;
    }
    catch {
        return null;
    }
}
function readConsentCookie() {
    try {
        const match = document.cookie.split('; ').find(c => c.startsWith(`${consentKey}=`));
        return match ? JSON.parse(decodeURIComponent(match.substring(consentKey.length + 1))) : null;
    }
    catch {
        return null;
    }
}
function persistConsent(state) {
    const stateString = JSON.stringify(state);
    try {
        document.cookie = `${consentKey}=${encodeURIComponent(stateString)};path=/;max-age=31536000;SameSite=Lax;Secure`;
    }
    catch {
    }
    try {
        localStorage.setItem(consentKey, stateString);
    }
    catch {
    }
}
export function consentHandler() {
    return {
        consentState: {
            hasConsent: true,
            cookies: false,
            details: {
                minimum: false,
                pixel: false,
            },
        },
        shouldShowMore: false,
        init() {
            var _a;
            const consentState = (_a = readStoredConsent()) !== null && _a !== void 0 ? _a : readConsentCookie();
            if (consentState) {
                this.consentState = consentState;
                if (consentState.hasConsent && !readConsentCookie()) {
                    persistConsent(consentState);
                }
            }
            else {
                this.consentState = {
                    hasConsent: false,
                    cookies: false,
                    details: {
                        minimum: false,
                        pixel: false,
                    },
                };
            }
        },
        handleConfirm() {
            const pixel = document.getElementById('pixel');
            this.consentState = {
                hasConsent: true,
                cookies: true,
                details: {
                    minimum: true,
                    pixel: pixel ? pixel.checked : false,
                },
            };
            persistConsent(this.consentState);
        },
        handleShowMore() {
            this.shouldShowMore = !this.shouldShowMore;
        }
    };
}
